<template>
  <div class="sidebar-section">
    <div class="sidebar-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSidebar",
  props: ["lessonDetail"],
};
</script>

<style lang="scss" scoped>
.sidebar-section {
  background-color: #024089;
  height: 100%;
  width: 100%;

  .sidebar-wrapper {
    height: 100%;
    padding: 50px 8px 50px 25px;
    width: 260px;
  }
}
@media (max-width: 475px) {
  .sidebar-section {
    .sidebar-wrapper {
      padding: 20px 15px;
    }
  }
}
</style>
